import api from './axios';

/**
 * Get the single active cycle (server returns 404 if none).
 * Response shape (example): { id, name, start_date, end_date, status_id, ... }
 */
export async function getActiveCycle() {
    const { data } = await api.get('/api/cycles/active');
    return data; // object or throws if 404
}

/**
 * (Optional) List cycles with filters.
 * Example: listCycles({ status: 'Active' })
 */
export async function listCycles(params = {}) {
    const { data } = await api.get('/api/cycles', { params });
    // if your controller paginates, adjust accordingly
    return data?.data ?? data;
}
